// "gmat_verbal": null,
//   "gmat_quant": null,
//   "gmat_data_insights": null,

export const GMAT_TESTING_TYPES = ['gmat'];
const isGmatTestingType = (type: string) => GMAT_TESTING_TYPES.includes(type);

interface StandardGmatItem {
  type: string;
  total: number;
  verbal: number;
  quant: number;
  data_insights: number;
}

export default class GmatConverter {
  static is = isGmatTestingType;
  static isValid = (item: StandardGmatItem) => {
    return item.total > 0 || item.quant > 0 || item.data_insights > 0 || item.verbal > 0;
  };

  static toArray(resume: Record<string, any>) {
    return GMAT_TESTING_TYPES.map((type) => {
      const typeObj = resume[`${type}_test_score`];
      if (typeObj) return { type, ...typeObj };
      return {
        type,
        total: resume[type] || null,
        quant: resume[`${type}_quant`] || null,
        data_insights: resume[`${type}_data_insights`] || null,
      };
    });
  }

  static toValidArray(resume: Record<string, any>) {
    return this.toArray(resume).filter(this.isValid);
  }

  static toObject(items: StandardGmatItem[]) {
    const resume = {};
    items.forEach((item) => {
      const { type, total, quant, data_insights, verbal } = item;
      resume[type] = total;
      resume[`${type}_quant`] = quant;
      resume[`${type}_data_insights`] = data_insights;
      resume[`${type}_verbal`] = verbal;

      resume[`${type}_test_score`] = {
        total,
        quant,
        data_insights,
        verbal,
      };
    });
    return resume;
  }

  static defaults() {
    return {
      gmat: null,
      gmat_quant: null,
      gmat_data_insights: null,
      gmat_verbal: null,

      // v2
      gmat_test_score: {
        total: null,
        quant: null,
        data_insights: null,
        verbal: null,
      },
    };
  }
}
